import Vue from 'vue'
import VueRouter from 'vue-router'

import Footer from '@/components/Footer.vue'
import Register from '@/views/Register.vue'
import Index from '@/views/Index.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'Index',
      path: '/',
      components: {
        default: Index,
        footer: Footer
      }
    },
    {
      name: 'Register',
      path: '/register',
      components: {
        default: Register,
        footer: Footer
      }
    },
    {
      name: 'fallback',
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
